export default [
  {
    path: '/email-config',
    name: 'emailconfig',
    component: () => import('@/app-modulo/comuns/email-config/EmailConfiguracao.vue'),
    meta: {
      resource: 'email',
      action: 'create',
      pageTitle: 'Configurações de E-mails',
      breadcrumb: [],
    },
  },
]
